import { render } from "./LastPwChange.vue?vue&type=template&id=0d8cf5f8"
import script from "./LastPwChange.vue?vue&type=script&lang=js"
export * from "./LastPwChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__